<template>
    <div v-if="lodgings > 0" class="w-full" style="background-color: #F4F4F4">
  <div class="max-w-7xl mx-auto py-20">
      <div class="mx-6 md:mx-14">
        <div class="flex mb-5">
          <h1 class="text-3xl">
            {{ headline }}
          </h1>
        </div>
        <div
          v-for="trip in lodgings"
          class="w-full border rounded-md mb-10 bg-white flex flex-col md:flex-row "
        >
          <figure class="relative h-60 flex flex-row sm:mb-5 md:h-72 md:w-1/2 md:mb-0">
            <img
              class="w-full h-full rounded-t-md object-cover md:rounded-l-md md:rounded-r-none"
              :src="trip.media.length > 0 ? trip.media[0].original_url : ''"
              :alt="trip.media.length > 0 ? trip.media[0].name : ''"
            >
          </figure>
          <div class="h-full p-6 flex flex-col md:justify-center md:w-1/2 md:mt-0">
            <h1 class="text-2xl lg:text-md">
              {{ trip.name }}
            </h1>
            <div class="mt-4 text-sm lg:text-md xl:flex">
              <p class="text-gray-600 flex items-center">
                <svg
                  width="12"
                  height="13"
                  class="mr-2"
                  viewBox="0 0 12 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.75 3.27177C0.75 2.61242 1.27233 2.0779 1.91667 2.0779H10.0833C10.7277 2.0779 11.25 2.61242 11.25 3.27177V10.435C11.25 11.0944 10.7277 11.6289 10.0833 11.6289H1.91667C1.27233 11.6289 0.75 11.0944 0.75 10.435V3.27177Z"
                    fill="white"
                  />
                  <path
                    d="M3.66667 3.27177V0.884033M8.33333 3.27177V0.884033M3.08333 5.65952H8.91667M1.91667 11.6289H10.0833C10.7277 11.6289 11.25 11.0944 11.25 10.435V3.27177C11.25 2.61242 10.7277 2.0779 10.0833 2.0779H1.91667C1.27233 2.0779 0.75 2.61242 0.75 3.27177V10.435C0.75 11.0944 1.27233 11.6289 1.91667 11.6289Z"
                    stroke="#01798A"
                    stroke-width="1.3166"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <formatted-date-range :from="trip.start" :to="trip.end" />
              </p>
              <p class="text-gray-600 flex items-center mt-2">
                <svg
                  width="12"
                  height="13"
                  class="mr-2"
                  viewBox="0 0 12 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.30048 9.03628C8.88345 9.46304 8.11904 10.2453 7.4309 10.9494C6.6463 11.7523 5.35485 11.7522 4.57024 10.9493C3.89547 10.2588 3.14306 9.48883 2.70082 9.03628C0.878373 7.17134 0.878373 4.14768 2.70082 2.28274C4.52327 0.417798 7.47804 0.417798 9.30048 2.28274C11.1229 4.14768 11.1229 7.17134 9.30048 9.03628Z"
                    stroke="#01798A"
                    stroke-width="1.16667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.75065 5.65951C7.75065 6.64854 6.96715 7.45031 6.00065 7.45031C5.03415 7.45031 4.25065 6.64854 4.25065 5.65951C4.25065 4.67047 5.03415 3.86871 6.00065 3.86871C6.96715 3.86871 7.75065 4.67047 7.75065 5.65951Z"
                    stroke="#01798A"
                    stroke-width="1.16667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {{ trip.place.area }}
              </p>
            </div>
            <p class="text-lg mt-5">
              {{ trip.description }}
            </p>
          </div>
        </div>
      </div>
  </div>
    </div>
</template>

<script setup>
import FormattedDateRange from "@/ComponentsDeprecated/Time/FormattedDateRange";
import { computed } from 'vue'

const props = defineProps({
  destinationId: {
    type: String
  },
  accomodations: {
    type: Array,
    required: true,
  },
  headlines: {
    type: Object,
    required: true
  },
  pivotId: {
    type: Object,
    required: true
  }
});

const destination = props.accomodations.filter(entry => entry.destination_id === props.destinationId )
const lodgings = destination.filter(lodging => lodging.type === 'lodging')

const headline = computed(() => {
  if (props.headlines?props.headlines[props.pivotId]:'') {
    return props.headlines[props.pivotId];
  } else {
    return 'Overnatting'
  }
})

</script>

